import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((MUITheme) => ({
    FAQlink: {
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
        color: MUITheme.palette.text.lightGrey,
        fontSize: 14,
        lineHeight: "18px",
        transition: "all 0.2s",
        "&:hover": {
            color: MUITheme.palette.text.darkGrey,
            transition: "all 0.2s",
        },
    },
}));
